// extracted by mini-css-extract-plugin
export default {"container":"BoxModal_container__UDM66","heading":"BoxModal_heading__DpIQ+","formContent":"BoxModal_formContent__+S9q1","subContainer":"BoxModal_subContainer__ebrJm"};